module.exports = __webpack_public_path__ + "img/scanner.2b8f06a4.jpg";